import calendarIcon from "../../assets/calendar-2.svg";
import greentick from "../../assets/righttick.svg";
import pdf from "../../assets/XMLID_2268_.svg";
import dummypdf from "../../assets/svgs/dummypdf.pdf";
import arrowleft from "../../assets/arrowleft.png";
import profilering from "../../assets/profilering.png";
import face from "../../assets/profile.png";
import filterDark from "../../assets/Filter-Fill.svg";
import CalendarDark from "../../../src/assets/calendar icon.svg";
import summarizedpng from '../../assets/summarized.png'
import checkmark from '../../assets/checkmark.png'
import doc from '../../assets/doc.png'
import DescriptionIcon from '@mui/icons-material/Description';
import { DateTime } from 'luxon';
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Backdrop, CircularProgress, Tooltip } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import EditNoteIcon from "@mui/icons-material/EditNote";
import MainHeader from "header/header";
import api from "../../api/api";
import { formatDate } from "utils/date";
import CloseIcon from "@mui/icons-material/Close";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import DatePicker from "../../version2/utils/singledatepicker";
import { formatDateToYMD } from "utils/date";
import { decodeTimeToISO } from "utils/date";
import { NavigateNext } from "@mui/icons-material";
import PdfRender from "./pdfrender";
import ToastMessage from "utils/muialerts/righttoptoast";
import Ring from "pages/landing/ring";
import SimpleModal from "alerts/recordingscreen/simplemodal";
import { FaInfoCircle } from "react-icons/fa";
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import PromptModal from "../../alerts/recordingscreen/promptmodal";
import SideBarWrapper from "version2/sidebarwrap";
import V2header from "version2/v2header";
import v2calander from '../../assets/calenderv2.png'
import infov2 from '../../assets/infov2.png'
import { formatDatev2 } from "utils/date";
import useModalStore from "zustand/zustandstore";
import { faCalendar, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AudioModal from "basic/modals/audiomodal";
import backarraow from '../../assets/backarraow.png'
import { convertToddmmyyy } from "utils/date";
const Archive = () => {
  const [isRecording, setIsRecording] = useState(false);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [selectedVisits, setSelectedVisits] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const location = useLocation();
  const { setModalValue } = useModalStore()
  const { ts,profile_photo } = location.state || {};
  const navigate = useNavigate();
          const [loguser,setLoguser]=useState('')
  const [audioSrc, setAudioSrc] = useState(null);
  const [loading,setLoading]=useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
  const[showinfo,setShowInfo]=useState(false)
  const[currentobj,setcurrentobj]=useState({})
  const [promptmodal,setPromptModal]=useState(false)
  const [perPage,setPerPage]=useState(4)
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [today, setToday] = useState("");
  const mydata=useModalStore()
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isPickerOpen, setIsPickerOpen] = useState(false); // State to toggle DatePickerWithSlider
  const [datestate, setDateState] = useState([
    { startDate: new Date(ts), endDate: new Date(ts), key: "selection" },
  ]);
  useEffect(() => {
    if (mydata.selectedRecord?.ts) {
      const formattedDate = new Date(mydata.selectedRecord.ts);
      setDateState([
        {
          startDate: formattedDate,
          endDate: formattedDate,
          key: "selection",
        },
      ]);
      fetchdata(formattedDate)
    }
  }, [mydata.selectedRecord?.ts]);
  const [pdffile,setPdffile]=useState()
  // const [value, setValue] = useState([420, 1140]); // Example: 10:00 AM to 12:00 PM
  const [value, setValue] = useState([1, 1439]); // 12:01 AM to 11:59 PM

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [uniqueVisitType, SetUniqueVisitType] = useState([]);
  const [uniqueProvider, setUniqueProvider] = useState([]);
  const [showdate, setShowdate] = useState("");
  const [ispdfshow,setIspdfShow]=useState(false)
  const[mycard,setMyCard]=useState('')
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const[myimgurl,setMyimgUrl]=useState(false)
  const percentage=100
  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${percentage * 3.6}deg)`,
  };

  function checkImage(url) {
    const img = new Image();
    img.onload = function() {
        console.log("Image loaded successfully");
        setMyimgUrl(true)
    };
    img.onerror = function() {
        console.log("Failed to load image");
        setMyimgUrl(false)
    };
    img.src = url;
  }
const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }
    setOpen(false);
};

useEffect(() => {
  let interval = null;
  if (data.some((item) => item.transcriptionstatus === "Processing")) {
    interval = setInterval(() => {
      setElapsedTime((prevTime) => prevTime + 1);
    }, 1000);
  } else {
    setElapsedTime(0);
  }
  return () => {
    if (interval) clearInterval(interval);
  };
}, [data]);
const renderStatus = (item) => {
 

  // Render progress or status based on transcription status
  if (item.transcriptionstatus === null || item.transcriptionstatus === "") {
    return "Ready";
  } else if (item.transcriptionstatus === "Submitted") {
    return <Ring value={20} />;
  } else if (item.transcriptionstatus === "Processing") {
    const recording_duration = item.recording_duration || 200; // Fallback to a default value
    const totalProcessingTime = Math.max((420 / 1287) * recording_duration, 60);
  
  const recordingStartTime = DateTime.fromISO(item.ts).toSeconds();


// Current time in UTC, rounded to whole seconds
const currentTime = Math.floor(DateTime.now().toSeconds()); // or you can use Math.round() if you prefer rounding

    const elapsedSinceStart = Math.max(currentTime - recordingStartTime, 0);

    // Calculate the initial percentage based on the elapsed time
    const completionPercentage = Math.min(
      Math.round(20 + (70 * elapsedSinceStart) / totalProcessingTime),
      90
    );
 





return <Ring value={completionPercentage} />;

  } else if (item.transcriptionstatus === "Summarized") {
    return (
      <div className="ml-2">
        <Tooltip title="Pending Review">
          <img src={summarizedpng} alt="pending review" className="w-6 h-6" />
        </Tooltip>
      </div>
    );
  } else if (item.transcriptionstatus === "APPROVED") {
    return (
      <div className="ml-2">
        <Tooltip title="Completed">
          <img src={checkmark} alt="Completed" className="w-6 h-6" />
        </Tooltip>
      </div>
    );
  } else {
    return null;
  }
}
  useEffect(() => {
    const date = new Date(ts); // Convert to a JavaScript Date object
    // Format the date as: "Monday, September 23, 2024"
    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    setShowdate(formattedDate);
  }, [ts]);
  const { id } = useParams();

  const handlepdf = async (value,card) => {

    if(card.transcriptionstatus=='Processing'){
      setMessage('Update in process. Hold on!');
      setSeverity('info'); // Change severity as needed
      setOpen(true);
      return
    }

    try {
      // Trigger loading spinner
      setIsLoading(true);

      const uniqueParam = new Date().getTime(); // or use a random number: Math.random()

    // Fetch the PDF from the server with a unique parameter to prevent caching
    const response = await api.get(`/v1/documents/PDF/${value}?_=${uniqueParam}`, {
      responseType: "blob", // Ensure response type is 'blob' for binary data
    });
      // Fetch the PDF from the server
      // const response = await api.get(`/v1/documents/PDF/${value}`, {
      //   responseType: "blob", // Ensure response type is 'blob' for binary data
      // });
      // // Create a Blob from the PDF data
      const pdfBlob = new Blob([response], { type: "application/pdf" });

      // Generate a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setMyCard(card)
      setPdffile(pdfBlob)
      // Open the generated URL in a new tab
      //window.open(pdfUrl, "_blank");

    } catch (error) {
      console.error("Error fetching the PDF:", error);
    } finally {
      // Turn off loading spinner
      setIsLoading(false);
      setIspdfShow(true)
    }
  };

  let payload = {
    filter_array: {
      date_filter: {
        start_date:formatDateToYMD(datestate [0].startDate),
        end_date: formatDateToYMD(datestate [0].endDate),
        startTime: decodeTimeToISO(value[0]),
        endTime: decodeTimeToISO(value[1]),
      },
    },
 
  };

  const fetchdata = async (a) => {
    setIsLoading(true);

 if(a){
   payload.filter_array.date_filter.start_date=formatDateToYMD(a)
   payload.filter_array.date_filter.end_date=formatDateToYMD(a)
 }
    const user = await api.get("/auth/me");
         setLoguser(user)
    try {
      let response = await api.post(
        `/v1/patient/${id}/recording/details`,
        payload
      );    
      if (response.status == 200) {
        let updatedData = response.data.map(item => ({
          ...item,
          patientid: id
        }));
        
        setData(updatedData);
      
      } else{

        setData([])
      }
    
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };



  
  const Loaddata = async () => {

      try {
      let response = await api.post(
        `/v1/patient/${id}/recording/details`,
        payload
      );    
      if (response.status == 200) {
       console.log(id,'id')
        let updatedData = response.data.map(item => ({
          ...item,
          patientid: id
        }));
        console.log(updatedData,'upda')
        setData(updatedData);
      } else{
        setData([])
      }
    
    } catch (error) {
      console.log(error);
    } finally {
    
    }
  };
  useEffect(() => {    

    fetchdata();  
 
  }, [id,location.pathname]);
useEffect(()=>{
  if (typeof loguser === 'object' && loguser !== null) {
checkImage(`https://api.prd.brainymed.com/bs/patient-profile-pictures/${loguser?.config?.practiceid}/${mydata.selectedRecord?.patientid}.png`)
  }

},[mydata,loguser])
  useEffect(() => {
    const interval = setInterval(() => {
      Loaddata();
    }, 4000); // 2000ms = 2 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [id,location.pathname,datestate]);
  useEffect(() => {
    const sorted = [...data].sort((a, b) => new Date(a.ts) - new Date(b.ts));
    setSortedData(data);
  }, [data]);
  const handleVisitClick = (visit) => {
    setSelectedVisits(
      (prev) =>
        prev.includes(visit)
          ? prev.filter((item) => item !== visit) // Remove if already selected
          : [...prev, visit] // Add if not selected
    );
  };
  const handleProviderClick = (provider) => {
    setSelectedProviders((prev) =>
      prev.includes(provider)
        ? prev.filter((item) => item !== provider)
        : [...prev, provider]
    );
  };
  const toggleDatePicker = () => {
    !isPickerOpen && setIsPickerOpen(true);
  };
  const handledateclose = () => {
    const { startDate, endDate } = datestate [0];

    // Check if startDate and endDate are not the same
    // if (startDate.getTime() !== endDate.getTime()) {
    //   payload.filter_array.date_filter.end_date = formatDateToYMD(
    //     datestate[0].endDate
    //   );
      
    // } else {
    //   delete payload.filter_array.date_filter.end_date;
    // }
    payload.filter_array.date_filter.end_date = formatDateToYMD(
      datestate[0].endDate
    );
    payload.filter_array.date_filter.start_date = formatDateToYMD(
      datestate[0].startDate
    );
    payload.filter_array.date_filter.startTime = decodeTimeToISO(value[0]);
    payload.filter_array.date_filter.endTime = decodeTimeToISO(value[1]);

    fetchdata();
    setIsPickerOpen(!true);
  };
  const handleDateChange = (newRange) => {
    setDateState(newRange);
  };
  // useEffect(() => {
  //   SetUniqueVisitType([
  //     ...new Set(data.map((record) => record.purpose.toUpperCase())),
  //   ]);
  //   setUniqueProvider([
  //     ...new Set(data.map((record) => record.providername.toUpperCase())),
  //   ]);
  // }, [data]);
  useEffect(() => {
    if (data && Array.isArray(data)) {
      // Safely map over `purpose` and ensure valid strings
      SetUniqueVisitType([
        ...new Set(
          data.map((record) => record?.purpose?.toUpperCase() || "UNKNOWN") // Fallback to "UNKNOWN"
        ),
      ]);
  
      // Safely map over `providername` and ensure valid strings
      setUniqueProvider([
        ...new Set(
          data.map((record) => record?.providername?.toUpperCase() || "UNKNOWN") // Fallback to "UNKNOWN"
        ),
      ]);
    } else {
      // Handle case where `data` is invalid or empty
      SetUniqueVisitType([]);
      setUniqueProvider([]);
    }
  }, [data]);
  const handleplay=async(audio_link)=>{
    try {
      setLoading(true)
      const response = await api.get(`/v1/audio/${audio_link}`, {
        responseType: "blob", // Make sure response is treated as a Blob
      });
      const fileBlob = response;
      const audioURL = URL.createObjectURL(fileBlob);
          setAudioSrc(audioURL);
          if(fileBlob&&fileBlob.size==0){
         setAudioSrc('')
         alert('')
          }
        setIsModalOpen(true)
    } catch (error) {
      console.log(error)
    }finally{
  setLoading(false)
    }
   }

  const [currentPage, setCurrentPage] = useState(1);


  const indexOfLastData = currentPage * perPage; // Last index of current page
  const indexOfFirstData = indexOfLastData - perPage; // First index of current page
  const currentData = sortedData.slice(indexOfFirstData, indexOfLastData); // Get current page data
  const totalPages = Math.ceil(sortedData.length / perPage);
useEffect(()=>{
  console.log(currentData.length)
},[currentData])
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setAudioSrc(null); // Reset audio source when modal closes
  };
  return (
    <>
<div className="div  flex-col justify-start">


    <V2header/>

    <div className='flex relative w-full gap-8  items-start p-4 h-auto'>
      <div onClick={()=>navigate(-1)} className="cursor-pointer">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <g clip-path="url(#clip0_7403_35126)">
    <path d="M22 11.6875H2.68555L11.1396 20.1416L10.1729 21.1084L0.0644531 11L10.1729 0.891602L11.1396 1.8584L2.68555 10.3125H22V11.6875Z" fill="black"/>
  </g>
  <defs>
    <clipPath id="clip0_7403_35126">
      <rect width="22" height="22" fill="white"/>
    </clipPath>
  </defs>
</svg>
      </div>


<div className="flex gap-4">
 {mydata.selectedRecord?<><div>
          <div
  className="relative flex justify-center items-center w-[83px] h-[83px] rounded-full ml-4"
  style={circleStyle}
>
<div className="flex justify-center items-center w-[70px] h-[70px] bg-[#FAFAF9] rounded-full">
  <img
         src={myimgurl&&loguser?`https://api.prd.brainymed.com/bs/patient-profile-pictures/${loguser?.config?.practiceid}/${mydata.selectedRecord?.patientid}.png`:
         'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
         alt="profile"
         className="flex justify-center items-center w-[60px] h-[60px] bg-[#C4C4C4] rounded-full"
       />
  </div>
</div>  
        </div>
        <div className="text-start font-sans  font-normal">
  {mydata.selectedRecord?.patient_name ||mydata.selectedRecord?.patientid ? (<>
    <div className="text-xxl flex items-center gap-4 sm:text-2xl text-gray-600">
      {mydata.selectedRecord?.patient_name} 
    </div>
    <div className="text-xxl text-gray-600">
    {mydata.selectedRecord?.patientid ? `${mydata.selectedRecord?.patientid}` : ''}
    </div>
    <div className="text-xxl text-gray-600">
    {convertToddmmyyy(mydata.selectedRecord?.dob)||''}
    </div>
 </>) : null}
</div></>:<></>}

</div>
    

  </div>
  
      <div
        className={`flex ${
          isPickerOpen ? " md:items-start sm:min-h-[100vh]" : "items-center"
        } items-center mt-8 justify-center w-full  sm:h-auto md:h-auto`}
      >
        <div className="w-[95%] md:w-[45%] h-min-[50px] h-auto md:mt-10   p-6  bg-white rounded-[20px] shadow-[0px_2px_13px_#00000040]">


<div className="w-full  flex items-center relative mt-2">
  <div className="absolute left-[45%] transform -translate-x-1/2 font-semibold text-[#000000] text-[20px] tracking-[0] leading-[normal] whitespace-nowrap cursor-pointer">
    Archive
  </div>
  <FontAwesomeIcon     onClick={toggleDatePicker} icon={faCalendar} className="ml-auto cursor-pointer" />

  {isPickerOpen && (
                  <div className="absolute md:top-6 top-8 right-[-26px]   z-20 sm:top-6 sm:right-[-450%] md:right-0 ">
                    
                       <DatePicker
                                          handleDateClose={handledateclose}
                                          datestate={datestate}
                                          handledateChange={handleDateChange}
                                          value={value}
                                          setValue={setValue}
                                          setIsPickerOpen={setIsPickerOpen}
                                        />
                  </div>
                )}
             
</div>


        
          <div
           className="w-max-lg  h-auto py-8 gap-4 flex flex-col  justify-center items-center px-2"
          
          >
         {currentData && currentData.length > 0 ? (
  currentData.map((card, index) => (
    <div
      key={index}
      onClick={() => {
        if (card.transcriptionstatus === 'Processing') {
          setMessage('Update in process. Hold on!');
          setSeverity('info'); // Change severity as needed
          setOpen(true);
          return;
        }else{
        handlepdf(card.audiolink.split(".")[0],card,)
 
        }
       
      }}
        className="flex items-center justify-between cursor-pointer p-6 bg-white shadow-md rounded-[10px] w-full h-16 "
      style={{ boxShadow: "0 1px 4px rgba(0, 0, 0, 0.25)" }}
    >
    

    <div className="flex items-center gap-4">
    <div className="flex w-10 h-10 rounded-full items-center justify-center bg-[#DBEAFE]">
       
           <DescriptionIcon style={{color:"#2563EB"}}/>
        </div>
        <div
          style={{ cursor: "pointer" }}
         className="[font-family:'Poppins-Regular',Helvetica] text-left font-normal  text-[#1E293B] text-sm tracking-[0] leading-[normal]"
        >
          {formatDatev2(card.ts)}
        </div>
      </div>
      <div className="flex flex-row gap-6">
          <div 
                onClick={(e)=>{
                  e.stopPropagation()
                  handleplay(card.audiolink);
        
                }}
                className="cursor-pointer">
                    <FontAwesomeIcon icon={faPlay} className="text-[#94A3B8] w-5 h-5 mb-1"/>
                </div>
 {(() => {
  if (card?.transcriptionstatus === 'Processing') {
    return (
      <div className="w-7 h-7">
        {/* <Ring value={Math.floor(card?.handling_time)} /> */}
        { renderStatus(card)}
      </div>
    );
  } else if (card?.transcriptionstatus === 'Summarized') {
    return (
      <div className="w-7 h-7">
       <Tooltip title="Pending Review">
        <div onClick={(e)=>{
                     e.stopPropagation();
                     setModalValue({selectedRecord :card})  
                     setModalValue({ screen :1}) 
                     if (!location.pathname.startsWith('/v2')) {
                      navigate('/v2', { state: { back: true, selectedRecord:card } });
                    }
                    
                 }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 25 31" fill="none">
  <path d="M7.87484 17.0423C7.87484 18.2689 8.36211 19.4453 9.22947 20.3127C10.0968 21.18 11.2732 21.6673 12.4998 21.6673C13.7265 21.6673 14.9029 21.18 15.7702 20.3127C16.6376 19.4453 17.1248 18.2689 17.1248 17.0423C17.1248 15.8157 16.6376 14.6393 15.7702 13.7719C14.9029 12.9046 13.7265 12.4173 12.4998 12.4173C11.2732 12.4173 10.0968 12.9046 9.22947 13.7719C8.36211 14.6393 7.87484 15.8157 7.87484 17.0423ZM24.8332 27.2019V9.33398L15.5832 0.0839844H3.24984C2.43209 0.0839844 1.64783 0.408835 1.06959 0.987072C0.491354 1.56531 0.166504 2.34957 0.166504 3.16732V27.834C0.166504 28.6517 0.491354 29.436 1.06959 30.0142C1.64783 30.5925 2.43209 30.9173 3.24984 30.9173H21.7498C22.4436 30.9173 23.0603 30.6861 23.5844 30.3007L16.7548 23.4711C15.5215 24.2727 14.0415 24.7507 12.4998 24.7507C10.4555 24.7507 8.49481 23.9385 7.04922 22.4929C5.60363 21.0473 4.7915 19.0867 4.7915 17.0423C4.7915 14.9979 5.60363 13.0373 7.04922 11.5917C8.49481 10.1461 10.4555 9.33398 12.4998 9.33398C14.5442 9.33399 16.5049 10.1461 17.9505 11.5917C19.396 13.0373 20.2082 14.9979 20.2082 17.0423C20.2082 18.584 19.7303 20.064 18.9286 21.2819L24.8332 27.2019Z" fill="#DE8276"/>
</svg>
        </div>
      </Tooltip>
      </div>
    );
  } else if (card?.transcriptionstatus === 'APPROVED') {
    return (
      <div className="w-7 h-7">
       <Tooltip title="Completed"><img 
       onClick={(e)=>{
        e.stopPropagation();
        setModalValue({selectedRecord :card})  
        setModalValue({ screen :1}) 
        console.log(card)
        if (!location.pathname.startsWith('/v2')) {
         navigate('/v2', { state: { back: true, selectedRecord:card } });
       }
       
    }}
       src={checkmark} alt="Completed" className="w-6 h-6" /></Tooltip>
      </div>
    );
  } else {
    return null; 
  }
})()}

 
        {
 (card.transcriptionstatus === 'APPROVED'|| card?.emr_posted_status) ? (
   (card.transcriptionstatus === 'APPROVED' ||(card?.handling_time === 100.0 && card.transcriptionstatus === 'Summarized')) ? (
      <>
        <div
          onClick={(e) => {
            e.stopPropagation();
            setcurrentobj(card)
            setShowInfo(true);
          }}
        >
   
  <><img src={infov2} alt="" /></>
        </div>

            </>
    ) : (
      <div className="w-5 h-5"></div>
    )
  ) : (
    <div className="w-5 h-5"></div>
  )
}
      </div>
 
 


      
    </div>
  ))
) : (
  <div>No data found</div>
)}

          </div>
        {currentData && currentData.length > 0? 
   <div className="w-full flex items-center justify-between">
    <div></div>
   <div>

   </div>
   {/* Pagination centered */}
   <div className="flex items-center">
     <div
       onClick={handlePreviousPage}
       className={`${currentPage === 1 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
     >
       <NavigateBeforeIcon />
     </div>
 
     <span className="mx-2">{currentPage}/{totalPages}</span>
 
     <div
       onClick={handleNextPage}
       className={`${currentPage === totalPages ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
     >
       <NavigateNext />
     </div>
   </div>
 
   {/* Dropdown aligned right without affecting center */}
   <div className="">
     <select
       value={perPage}
       onChange={(e) => setPerPage(Number(e.target.value))}
       className="ml-4 px-2 py-1 font-normal border rounded"
     >
       {[4, 6, 8].map(option => {
         const isDisabled = sortedData?.length && sortedData.length < option;
         return (
           <option
             key={option}
             value={option}
             disabled={isDisabled}
             style={isDisabled ? { color: '#999' } : {}}
           >
             {option} per page
           </option>
         );
       })}
     </select>
   </div>
 </div>
 
           
           :<></>}
         
        </div>
      </div>

      
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading||loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
        <AudioModal
              open={isModalOpen}
              onClose={handleCloseModal}
              audioSrc={audioSrc}
              loading={loading}
            />
      <SimpleModal isModalOpen={showinfo} setModalOpen={setShowInfo} data={currentobj}/>
      <PromptModal isModalOpen={promptmodal} setModalOpen={setPromptModal} data={currentobj}/>
      <ToastMessage
                open={open}
                message={message}
                severity={severity}
                handleClose={handleClose}
            />
      <PdfRender ispdfshow={ispdfshow}setIspdfShow={setIspdfShow} pdfBlob={pdffile} data={mycard}/>
</div>
    </>
  );
};

export default Archive;
